"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TARGETS = exports.CATEGORIES = void 0;
const CATEGORIES = exports.CATEGORIES = {
  CRITICAL: 'CRIT',
  ERROR: 'ERROR',
  WARNING: 'WARN',
  SUCCESS: 'SUCCESS',
  INFO: 'INFO',
  DEBUG: 'DEBUG'
};
const TARGETS = exports.TARGETS = {
  INTERNAL: 'INTERNAL',
  EXTERNAL: 'EXTERNAL'
};